import { useContext } from 'react'
import { UserLocaleContext } from '../contexts'

export const useUserLocale = () => useContext(UserLocaleContext)
